import { ToasterService } from "@topline/services/toasterService";
import { GridStateService } from "./gridStateService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(module => {
    module.component("gridStateComponent", {
        template: require('./gridStateComponent.html'),
        bindings: {
            grid: "<",
            gridName: "@",
            gridOptions: "<"
        },
        controller: [
            "$scope",
            "$timeout",
            "$filter",
            "$document",
            angularServicesNames.$uibModal,
            "$window",
            GridStateService.componentName,
            ToasterService.componentName,
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                $timeout: ng.ITimeoutService,
                $filter: ng.IFilterService,
                $document: ng.IDocumentService,
                $uibModal: ng.ui.bootstrap.IModalService,
                $window: ng.IWindowService,
                gridStateService: GridStateService,
                toasterService: ToasterService
            ) {
                var $ctrl = this;

                $ctrl.editMode = { item: 0 };
                $ctrl.listVisible = false;

                function isColumnChanges(dataFromLocalStorage: $TSFixMe) {
                    try {
                        const currectColumnNames = _.pluck(getColumnState(), "colId").sort();
                        for (let i = 0, max = dataFromLocalStorage.length; i < max; i++) {
                            const storageColumnNames = _.pluck(dataFromLocalStorage[i].grid, "colId").sort();

                            if (!_.isEqual(currectColumnNames, storageColumnNames)) {
                                return true;
                            }
                        }
                        return false;
                    } catch (error) {
                        return true;
                    }
                }

                function loadSaveGridView() {
                    gridStateService.getItem($ctrl.gridName).then((dataFromLocalStorage: $TSFixMe) => {
                        if (dataFromLocalStorage) {
                            if (isColumnChanges(dataFromLocalStorage)) {
                                resetViews();
                            }
                            prepareData(dataFromLocalStorage);
                        } else {
                            const defaultState = createDefaultState();
                            prepareData(defaultState);
                            gridStateService.setItem($ctrl.gridName, defaultState);
                        }
                    });
                }

                function resetViews() {
                    $ctrl.gridOptions.columnApi.resetColumnState();
                    const grisState = createDefaultState();
                    prepareData(grisState);
                    return gridStateService.setItem($ctrl.gridName, grisState).then(() => {
                        toasterService.warning("GRID_COLUMN_CHANGE_INFO");
                    });
                }

                function prepareData(list: $TSFixMe) {
                    for (let i = 0, max = list.length; i < max; i++) {
                        if (list[i].isDefault === true) {
                            const option = list[i].grid;
                            setColumnState(option);
                            $ctrl.selected = list[i];
                            break;
                        } else {
                            $ctrl.selected = list[0];
                        }
                    }
                    $ctrl.list = list;
                }

                function createDefaultState() {
                    const options = getColumnState();
                    return [
                        {
                            grid: options,
                            id: 1,
                            isDefault: true,
                            viewName: $filter("translate")("DEFAULT_VIEW")
                        }
                    ];
                }

                function getColumnState() {
                    const columnApi = $ctrl.gridOptions.columnApi;
                    return columnApi.getColumnState();
                }

                function setColumnState(state: $TSFixMe) {
                    const columnApi = $ctrl.gridOptions.columnApi;
                    return columnApi.setColumnState(state);
                }

                $ctrl.show = () => {
                    $ctrl.listVisible = !$ctrl.listVisible;
                };

                $ctrl.isSelected = (item: $TSFixMe) => item === $ctrl.selected;

                $ctrl.setEditable = (item: $TSFixMe) => {
                    $ctrl.editMode.item = item;
                };

                $ctrl.resetViews = () => {
                    resetViews();
                    $window.location.reload();
                };

                $ctrl.select = (item: $TSFixMe) => {
                    const content = item.grid;
                    setColumnState(content);
                    $ctrl.selected = item;
                    $ctrl.listVisible = false;
                };

                $ctrl.savePosition = () => {
                    let modalInstance = $uibModal.open({
                        component: "saveGridState"
                    });

                    modalInstance.result.then((result: $TSFixMe) => {
                        const gridPersistent = {
                            viewName: result.name,
                            isDefault: result.default || false,
                            grid: getColumnState()
                        };

                        if ($ctrl.list && $ctrl.list.length > 0) {
                            // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type '{ viewName: ... Remove this comment to see the full error message
                            gridPersistent.id = $ctrl.list.length + 1;
                            if (gridPersistent.isDefault) {
                                $ctrl.list.filter((item: $TSFixMe) => {
                                    if (item.isDefault === true) {
                                        return (item.isDefault = false);
                                    }
                                });
                            }
                            $ctrl.list.push(gridPersistent);
                        } else {
                            // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type '{ viewName: ... Remove this comment to see the full error message
                            gridPersistent.id = 1;
                            $ctrl.list = [gridPersistent];
                        }
                        gridStateService
                            .setItem($ctrl.gridName, $ctrl.list)
                            .then(() => loadSaveGridView());
                    });
                };

                $ctrl.updateElement = (item: $TSFixMe) => {
                    item.grid = getColumnState();
                    $ctrl.listVisible = false;

                    const indexElementToUpdate = _.findIndex(((e: $TSFixMe) => e.id == item.id) as $TSFixMe);

                    if (item.isDefault) {
                        for (const listItem of $ctrl.list) {
                            listItem.isDefault = false;
                        }
                        item.isDefault = true;
                    }
                    $ctrl.list[indexElementToUpdate] = item;

                    gridStateService.setItem($ctrl.gridName, $ctrl.list).then(() => loadSaveGridView());
                };

                $ctrl.removeElement = (id: $TSFixMe) => {
                    let indexElementToRemove = _.findIndex($ctrl.list, (item: $TSFixMe) => item.id == id);
                    if (indexElementToRemove >= 0) {
                        $ctrl.list.splice(indexElementToRemove, 1);
                        gridStateService.setItem($ctrl.gridName, $ctrl.list).then(() => {
                            loadSaveGridView();
                            $ctrl.listVisible = false;
                        });
                    }
                };

                $scope.$watch("$ctrl.gridName", (newVal: $TSFixMe) => {
                    if (newVal) {
                        $timeout(() => {
                            loadSaveGridView();
                        });
                    }
                });

                $scope.$watch("$ctrl.selected", () => {
                    $ctrl.display = $ctrl.selected;
                });

                $document.bind("click", function (event: $TSFixMe) {
                    const elem = angular.element(document.querySelector("grid-state-component")!);

                    let isClickedElementChildOfPopup = angular.element(elem[0]).find(event.target).length > 0;
                    if (isClickedElementChildOfPopup) {
                        return;
                    }
                    $ctrl.listVisible = false;
                    $scope.$apply();
                });
            }
        ]
    });
})(angular.module("topline.modules"));
